import { render, staticRenderFns } from "./getRecentDeposit.vue?vue&type=template&id=7b79df26&lang=pug"
import script from "./getRecentDeposit.vue?vue&type=script&lang=js"
export * from "./getRecentDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports